import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronUp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 8,
	viewBox: "0 0 14 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.6719 7.04688C13.1094 6.60938 13.082 5.92578 12.6445 5.51562L7.61328 0.703125C7.20312 0.292969 6.51953 0.292969 6.10938 0.703125L1.07812 5.51562C0.640625 5.92578 0.613281 6.60938 1.05078 7.04688C1.46094 7.48438 2.14453 7.51172 2.58203 7.07422L6.875 3L11.1406 7.07422C11.3594 7.29297 11.6328 7.375 11.9062 7.375C12.1797 7.375 12.4805 7.26562 12.6719 7.04688Z",
		fill: "#78909C"
	})]
});
const ForwardRef = forwardRef(SvgChevronUp);
export { ForwardRef as ReactComponent };
